<template>
    <div id="reports_create_page" class="container-fluid">
        <form>
            <div class="form-group">
                <label>SELECT CLIENT</label>
                <div class="col-md-4 col-lg-3 padding-x0">
                    <v-select v-model="selected_client" :reduce="client => client.id" label="name" :options="clients"></v-select>
                </div>
            </div>

            <div class="form-group">
                <label for="report_name">REPORT NAME</label>
                <input v-model="report_name" type="text" class="form-control col-md-5 col-lg-4 col-xl-3" id="report_name">
            </div>

            <div class="form-group">
                <label><p-input v-model="pull_data" type="checkbox" class="p-default p-curve single"> Pull data once report is created</p-input></label>
            </div>

            <div class="form-group">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label @click="setReportOption('blank_report')" class="btn btn-light active">
                        <input type="radio" autocomplete="off" checked> Blank Report
                    </label>

                    <label @click="setReportOption('copy_existing_report')" class="btn btn-light">
                        <input type="radio" autocomplete="off"> Use Existing Template
                    </label>
                </div>

                <div v-if="report_option === 'copy_existing_report'" class="reports-list d-inline-block">
                    <div class="col-md-4 col-lg-3 padding-x0">
                        <v-select :clearable="false" v-model="selected_report" :reduce="report => report.id" label="client_report_name" :options="reports"></v-select>
                    </div>
                </div>
            </div>

            <div v-if="client_data_connection_accounts.count > 0" class="form-group margin-top20">
                <div class="padding-bottom30">
                    <h5 class="pull-left margin-bottom0">Select your data sources ({{ client_data_connection_accounts.count }})</h5>

                    <div class="pull-right">
                        <input v-model="client_data_connection_accounts_filter" type="text" placeholder="Search accounts..." class="form-control search-accounts">
                    </div>
                </div>

                <table class="table table-borderless data-connection-accounts">
                    <tbody>
                        <template v-for="data_connection_accounts in client_data_connection_accounts.data">
                            <template v-if="isFilterMatch(data_connection_account)" v-for="data_connection_account in data_connection_accounts">
                                <tr>
                                    <td class="align-middle">
                                        <img :src="`${$store.state.app_url}images/data_sources/${data_connection_account.abbreviation}.png`">
                                        <span>{{ data_connection_account.name }}</span>
                                    </td>
                                    <td class="align-middle">
                                        <span>{{ data_connection_account.name_given_by_user }}</span>
                                    </td>
                                    <td class="align-middle">
                                        <span>{{ data_connection_account.primary_name_in_source }} ({{ data_connection_account.primary_account_id }})</span>
                                    </td>
                                    <td class="align-middle text-right">
                                        <button @click="connectOrDisconnect(data_connection_account.id)" type="button" class="btn reverse" :class="selected_accounts.indexOf(data_connection_account.id) > -1 ? 'btn-danger' : 'btn-info'">
                                            {{ selected_accounts.indexOf(data_connection_account.id) > -1 ? 'Disconnect' : 'Connect' }}
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>

            <div class="form-group text-center margin-top25">
                <button v-if="report_option === 'blank_report'" :disabled="save_disabled" id="save_report" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>CREATING...' @click="saveReport" type="button" class="btn btn-info btn-lg margin-left15">Create Blank Report</button>
                <button v-if="report_option === 'copy_existing_report'" :disabled="save_disabled" id="save_report" data-loading-text='<span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>COPYING...' @click="saveReport" type="button" class="btn btn-info btn-lg margin-left15">Copy Existing Report</button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        updated() {
            this.validateForm();
        },

        data() {
            return {
                clients:                                [],
                reports:                                [],
                selected_client:                        '',
                selected_report:                        '',
                report_name:                            '',
                client_data_connection_accounts_filter: '',
                client_data_connection_accounts:        {},
                selected_accounts:                      [],
                pull_data:                              true,
                report_option:                          'blank_report',
                save_disabled:                          true
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/clients'),
                    axios.get('/api/reports'),
                    axios.get('/api/clients/connected')
                ]).then(axios.spread((clients, reports, clientsConnected) => {
                    this.clients = clients.data;
                    this.reports = _.filter(reports.data, {client_name: 'KBP Templates'});

                    if (this.$route.params.client_id) {
                        this.selected_client = parseInt(this.$route.params.client_id);
                    }

                    if (this.reports.length > 0) {
                        this.selected_report = this.reports[0].id;
                    }

                    if (clientsConnected.data == 0) {
                        window.location = this.$store.app_url + '/page-not-found';
                        return;
                    }
                }));
            },

            connectOrDisconnect(accountId) {
                const index = this.selected_accounts.indexOf(accountId);

                if (index === -1) {
                    this.selected_accounts.push(accountId);
                } else {
                    this.selected_accounts.splice(index, 1);
                }
            },

            isFilterMatch(dataConnectionAccount) {
                if (!this.client_data_connection_accounts_filter.trim()) {
                    return true;
                }

                const regexp = new RegExp(`.*${this.client_data_connection_accounts_filter}.*`, 'i');

                return !!(dataConnectionAccount.primary_account_id.toString().match(regexp) || dataConnectionAccount.primary_name_in_source.match(regexp));
            },

            validateForm() {
                this.save_disabled = !(this.selected_client && this.report_name && this.report_option && this.selected_accounts.length);
            },

            setReportOption(option) {
                this.report_option = option;

                if (this.report_option === 'copy_existing_report' && this.reports.length > 0) {
                    this.selected_report = this.reports[0].id;
                } else {
                    this.selected_report = '';
                }
            },

            saveReport() {
                $('#save_report').button('loading');

                let formData = new FormData;
                formData.append('client_id', this.selected_client);
                formData.append('report_name', this.report_name);
                formData.append('selected_accounts', JSON.stringify(this.selected_accounts));
                formData.append('pull_data', this.pull_data);
                formData.append('report_option', this.report_option);
                formData.append('copy_from_report', this.selected_report);

                this.ajaxSubmit({'Content-Type': 'multipart/form-data'}, 'POST', '/api/reports', formData).then(response => {
                    $('#save_report').button('reset');

                    if (this.pull_data) {
                        this.$notify({
                            type:     'success',
                            duration: 7000,
                            text:     this.messages.REPORT_CREATED_WITH_PULL
                        });
                    } else {
                        this.$notify({
                            type: 'success',
                            text: this.messages.REPORT_CREATED
                        });
                    }

                    if (this.report_option === 'blank_report' && response.data.id) {
                        this.$router.push({path: `/reports/build/${response.data.id}`});
                    } else {
                        this.$router.push({path: '/reports'});
                    }
                });
            }
        },

        watch: {
            selected_client() {
                if (this.selected_client) {
                    axios.get(`/api/data-connections/clients/${this.selected_client}`).then(response => {
                        this.client_data_connection_accounts = response.data;
                    });
                } else {
                    this.client_data_connection_accounts = {};
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';

    #reports_create_page {
        .search-accounts {
            width: 20vw;
        }

        .data-connection-accounts {
            font-size: 1.2rem;

            td:first-child {
                font-weight: 500;
            }

            img {
                width: 3.2rem;
            }
        }

        div.vs__selected-options{
            overflow:hidden;

            @media screen and (max-width: 1260px) {
                font-size:1vw;
            }
        }

        .reports-list {
            font-size: 1.3rem;

            > div > div {
                width: 45rem;

                > div {
                    height: 3.5rem;
                }
            }
        }

        .btn-light {
            width: 15rem;
            margin-right: 1rem;
            border-radius: 0;

            &.focus {
                box-shadow: none !important;
            }
        }

        .pretty {
            line-height: 1.1;
        }

        .pretty.p-default input:checked ~ .state label::after {
            background-color:$secondary !important;
        }

        .pretty.p-switch input:checked ~ .state label::after {
            background-color:$secondary !important;
        }
    }
</style>
